// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__f7662238cda37d8b65f0","cls2":"CreateSocialItemModal-cls2___5ef0c0d19f4be1272e0 CreateSocialItemModal-cls1__f7662238cda37d8b65f0"};